"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgListen = function SvgListen(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 17"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#4D4D4D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.722 5.528C3.266 2.51 4.874 1 7.547 1 11.555 1 12 5.029 12 6.153c0 1.124-.944 2.965-1.973 4.053-.686.725-1.575 2.075-2.666 4.05C6.647 15.417 5.797 16 4.812 16 3.334 16 2 14.924 2 12.98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 5.845C9.68 3.948 8.855 3 7.522 3c-1.333 0-2.18.658-2.54 1.975.058.846-.097 1.469-.464 1.868-.55.6-.818 1.261 0 1.75.818.489.93 1.3.465 1.822-.465.523-1.61 1.471.465 2.585"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgListen);
var _default = exports["default"] = Memo;